import { Carousel } from 'antd';
import styled from 'styled-components';

export default styled(Carousel)`
	// Add your styles here
`;
